import { Box, Divider, Paper } from "@mui/material";
import { PageTitle } from "../../App/Components/PageTitle/PageTitle";
import { CampaignProfileState } from "../State/CampaignProfileState";
import CampaignButtons from "./CampaignButtons";
import { CampaignDetails } from "./CampaignDetails";

export default function CampaignHeader({ state }: { state: CampaignProfileState }) {
  const {
    getters: { campaign, isFetching },
    handlers: { handleOpenDeleteDialog, handleOpenEmbedScriptDialog },
  } = state;

  if (!campaign) {
    return null;
  }

  return (
    <Paper sx={{ mt: { xs: 1, md: 4 }, py: 1, px: { xs: 2, lg: 4 } }}>
      <Box
        sx={{
          display: "flex",
          gap: { xs: 1, md: 2 },
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: "100%", md: "50%" },
            display: "flex",
            flexDirection: "column",
            gap: 0,
            alignItems: { xs: "center", md: "flex-start" },
            justifyContent: "center",
            p: { xs: 1, md: 2 },
          }}
        >
          <PageTitle
            sx={{
              width: 1,
              lineHeight: 1,
              color: "secondary.main",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {campaign.name}
          </PageTitle>
          <CampaignButtons
            campaign={campaign}
            handleOpenDeleteDialog={handleOpenDeleteDialog}
            handleOpenEmbedScriptDialog={handleOpenEmbedScriptDialog}
          />
        </Box>

        <Divider
          orientation="vertical"
          flexItem
          variant="middle"
          sx={{ display: { xs: "none", md: "block" } }}
        />

        <Box sx={{ p: { xs: 1, md: 2 }, flex: 0, width: "100%" }}>
          <CampaignDetails campaign={campaign} isFetching={isFetching} />
        </Box>
      </Box>
    </Paper>
  );
}
